import React, { useState } from "react";
import logo from "../assets/logo.png";
import { FaBars, FaTimes } from "react-icons/fa";

function NavBar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false); // State for About modal

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleAboutModal = () => {
    setIsAboutModalOpen(!isAboutModalOpen); // Toggle the About modal visibility
  };

  return (
    <div className="flex justify-between items-center p-4 bg-white ">
      {/* Logo Section */}
      <div className="flex items-center">
        <img src={logo} alt="Linkup Logo" className="h-8" />
        <h1 className="text-2xl font-bold px-3 font-sans">Minglee</h1>
      </div>

      {/* Menu Icon for Smaller Screens */}
      <div className="block sm:hidden">
        <button onClick={toggleDropdown} className="text-xl focus:outline-none">
          {isDropdownOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Buttons for Larger Screens */}
      <div className="hidden sm:flex space-x-4">
        <button
          onClick={toggleAboutModal}
          className="bg-white text-custom-red px-4 py-2 rounded-lg text-md font-sans"
        >
          About Mingle
        </button>
        <button className="bg-custom-red text-white px-4 py-2 rounded-full text-md hover:bg-red-700 transition-colors font-sans">
          Invest In Mingle
        </button>
      </div>

      {/* Dropdown Menu for Smaller Screens */}
      {isDropdownOpen && (
        <div className="absolute top-16 right-4 bg-white shadow-lg rounded-lg w-48 p-4 space-y-2 sm:hidden">
          <button
            onClick={toggleAboutModal}
            className="w-full bg-white text-custom-red px-4 py-2 rounded-lg text-md font-sans"
          >
            About Mingle
          </button>
          <button className="w-full bg-custom-red text-white px-4 py-2 rounded-full text-md hover:bg-red-700 transition-colors font-sans">
            Invest In Mingle
          </button>
        </div>
      )}

      {/* About Minglee Modal */}
      {isAboutModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-4 relative">
            <button
              onClick={toggleAboutModal}
              className="absolute top-3 right-3 text-lg font-semibold"
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4">About Minglee</h2>
            <p className="mb-4">
              Minglee is a vibrant social app that connects you with places and
              people. Sign up to discover unforgettable experiences.
            </p>
            {/* <button
              onClick={toggleAboutModal}
              className="bg-red-500 text-white px-4 py-2 rounded-lg"
            >
              Close
            </button> */}
          </div>
        </div>
      )}
    </div>
  );
}

export default NavBar;
